import { FC } from 'react';
import { useModal } from 'shared/lib/modal';
import { usePaginationFilter } from 'shared/lib/pagination';
import { Filters } from 'shared/lib/pagination/types';
import { FilterIconButton } from 'shared/ui/buttons/iconButtons/filterButton';

interface FilterButtonProps {
	countExcludeFilters?: number;
}

export const FilterButton: FC<FilterButtonProps> = ({
	countExcludeFilters = 0,
}) => {
	const { openModal } = useModal();
	const filters = usePaginationFilter()?.displayFilters as Filters;

	return (
		<FilterIconButton
			onClick={openModal}
			showActive={
				Object.keys(filters).length - countExcludeFilters >= 1
					? true
					: false
			}
		/>
	);
};
